import React from "react";
import { RouteProps } from "react-router";

export default class Content {
  public Component: React.FC<RouteProps>;
  public title: string;
  public route: string;
  public tags?: string[];

  constructor({ Component, title, route, tags }: Content) {
    this.Component = Component;
    this.title = title;
    this.route = route;
    this.tags = tags;
  }
}
